import React from 'react';
import { Text } from '@fiverr-private/typography';
import { Stack } from '@fiverr-private/layout_components';
import { TagItemProps } from '../../../types';
import { useTagsContext } from '../TagsContext/TagsContext';

export const DefaultTagItem: React.FC<TagItemProps> = ({ label, icon }) => {
    const { tagsLayout } = useTagsContext();

    return (
        <Stack
            backgroundColor="grey_200"
            borderRadius="circle"
            paddingY={tagsLayout.paddingY}
            paddingX={tagsLayout.paddingX}
        >
            {icon && <img src={icon.src} width={tagsLayout.iconSize} height={tagsLayout.iconSize} alt={icon.alt} />}
            <Text size={tagsLayout.fontSize} as="span">
                {label}
            </Text>
        </Stack>
    );
};
